module.exports = __webpack_public_path__ + "img/165.99266882.png";